import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  DismissNewLeadersSuggestionsAction,
  NewLeadersSuggestionsLoadAction,
} from '../../domains/leadersManagement/actions.types';

import { NewLeadersSuggestions } from './types';

export type NewLeadersSuggestionsAction = NewLeadersSuggestionsLoadAction | DismissNewLeadersSuggestionsAction;

export const initialState: NewLeadersSuggestions = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<NewLeadersSuggestions, NewLeadersSuggestionsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NEW_LEADERS_SUGGESTIONS.LOAD_PENDING':
      return setPending();
    case 'NEW_LEADERS_SUGGESTIONS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.newLeadersSuggestions);
    case 'NEW_LEADERS_SUGGESTIONS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'NEW_LEADERS_SUGGESTIONS.DISMISS':
      return setFulfilled(action.payload.entities.newLeadersSuggestions);
    default:
      return state;
  }
};

export default reducer;
